module.exports = __webpack_public_path__ + "static/media/161007-DSC04982-15_Small.01baa914.jpg";